import { Group, Mesh, SphereGeometry, MeshBasicMaterial } from "three";
import type { Chapter } from "./index";

export function createCh4Release(onEnter: () => void, onExit: () => void): Chapter {
  const group = new Group();

  const colors = [0xfff0aa, 0xfff066, 0xffaaff, 0xff66aa];
  for (let i = 0; i < 4; i++) {
    const station = new Mesh(
      new SphereGeometry(0.4, 16, 16),
      new MeshBasicMaterial({ color: colors[i], transparent: true, opacity: 0.3 }),
    );
    const angle = (i / 4) * Math.PI * 2;
    station.position.set(Math.cos(angle) * 6, 0, Math.sin(angle) * 6);
    group.add(station);
  }
  group.visible = false;

  return {
    id: 4,
    enter(ctx) { ctx.scene.add(group); group.visible = true; onEnter(); },
    exit(_ctx) { group.visible = false; onExit(); },
    update(_ctx, t, _dt, _local) {
      group.rotation.y = t * 0.05;
    },
  };
}
